import React from 'react'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { ApiRepository } from 'repository/api-repository'
import SecretaryDetails from 'presentation/doctor/pages/SecretaryDetails'
import { RemoteUnlinkSecretary } from 'service/usecases/unlink-secretary/remote-unlink-secretary'
import { SecretaryRepository } from 'repository/repositories/secretary/secretary-repository'
import { RemoteUpdateUser } from 'service/usecases/user-update/user-update'
import { UserRepository } from 'repository/repositories/user/user-repository'

export default function makeDoctorSecretaryDetails() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const doctorRepository = new SecretaryRepository(apiRepository)

  const unlinkSecretary = new RemoteUnlinkSecretary(doctorRepository)
  const userRepository = new UserRepository(apiRepository)
  const updateSecretaryUser = new RemoteUpdateUser(userRepository)

  return (
    <SecretaryDetails
      unlinkSecretary={unlinkSecretary}
      updateSecretaryProfile={updateSecretaryUser}
    />
  )
}
